import { render, staticRenderFns } from "./facets-form.view.vue?vue&type=template&id=d1372072&scoped=true"
import script from "./facets-form.view.vue?vue&type=script&lang=ts"
export * from "./facets-form.view.vue?vue&type=script&lang=ts"
import style0 from "./facets-form.view.vue?vue&type=style&index=0&id=d1372072&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1372072",
  null
  
)

export default component.exports